"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const common_1 = require("../../common");
const ruleMatchChoices_1 = __importDefault(require("../../FilterField/ruleMatchChoices"));
function RuleMatchDropdown(props) {
    return (core_1.jsx(common_1.Dropdown, { initialSelectedItem: props.initialValue, items: ruleMatchChoices_1.default, menuAriaLabel: "rule conditions", onChange: props.onChange, placeholder: "Choose condition\u2026" }));
}
exports.default = RuleMatchDropdown;
